import React, { useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { HiMenu } from "react-icons/hi";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { MdErrorOutline } from "react-icons/md";
import * as applicationUserCrud from "../../../configurations/crud/applicationUserCrud";
import { useToast } from "../../controls/Toast/ToastService";
import LodingButton from "../../controls/LodingButton";
import { PiPhone } from "react-icons/pi";
import { Link } from "react-router-dom";
import Input from "../../controls/Input";
import Container from "../../base/Container";
import { CiLocationArrow1 } from "react-icons/ci";
import Card from "../../controls/Card";
import useGlobalLoader from "../../../configurations/useGlobalLoader";

const schema = yup.object().shape({
    OTP: yup.string().required("OTP is required."),
    NewPass: yup
        .string()
        .min(4, "Password must have 4 charactors")
        .max(4, "Password must have 4 charactors")
        .matches(/^(?=.*[0-9])/, {
            message:
                "Pin must digit.",
        })
        .required("New pin is required."),
    ConfirmPassword: yup
        .string()
        .oneOf(
            [yup.ref("NewPass"), null],
            "New Pin and Confirm Pin missmatch"
        )
        .required("Confirm pin is required."),
});

export default function ForgetPin() {
    const {start,end} = useGlobalLoader()
    const [level, setLevel] = useState(1);
    const [loding, setLoding] = useState(false)
    const toast = useToast()

    const {
        values,
        errors,
        isValid,
        handleBlur,
        handleChange,
        handleSubmit,
        touched,
        setValues,
    } = useFormik({
        initialValues: {
            UserName: "username",
            OTP: "",
            NewPass: "",
            ConfirmPassword: "",
        },
        validationSchema: schema,
        onSubmit(values) {
            handleForgetPin(values)
        }
    });


    function handleForgetPin(val) {
        setLoding(true)
        start()
        applicationUserCrud.ForgotPin(values).then(res => {
            if (res.data) {
                let data = res.data
                if (data.succeeded) {
                    setValues({ ...values, OTP: "", NewPass: "", ConfirmPassword: "" })
                    setLevel(0)
                    toast.open("Pin has been changed successfully.", <IoCheckmarkDoneCircleOutline />, "success")
                } else {
                    if (data.code === 108) {
                        setLevel(2)
                        toast.open(data.message, <MdErrorOutline />, "danger")
                    }
                    else {
                        toast.open(data.message, <MdErrorOutline />, "danger")
                    }
                }
            }
            else {
                toast.open("Server Error", <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            toast.open(errors, <MdErrorOutline />, "danger")
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    const handleInitiateForgrtPin = () => {
        setLoding(true)
        start()
        values.UserName = "username";
        if (values.UserName) {
            applicationUserCrud.ForgotPinInitiate(values).then(res => {
                if (res.data) {
                    let data = res.data
                    if (data.result.succeeded) {
                        setLevel(2)
                        toast.open("Otp sent successfully.", <IoCheckmarkDoneCircleOutline />, "success")
                    } else {
                        toast.open(data.result.message, <IoCheckmarkDoneCircleOutline />, "success")
                    }
                }
                else {
                    toast.open("Server Error", <MdErrorOutline />, "danger")
                }
                setLoding(false)
                end()
            }).catch(errors => {
                setLoding(false)
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
        }
        else {
            toast.open("Please enter Mobile/ User", <MdErrorOutline />, "danger")
            setLoding(false)
            end()
        }
    }

    return (
        <Container heading={<>Manage Specialisation <CiLocationArrow1 /></>}>
            <div class="w-full md:w-4/12 md:mx-2"></div>
            <div class="w-full md:w-4/12 md:mx-2">
                <Card title={"Forgot Pin"} isBorder={true}>
                    <form className="px-2" onSubmit={handleSubmit} autoComplete="off">
                        <div className="mt-5 sm:mx-auto sm:w-full sm:max-w-sm ">
                            <div className="space-y-3">
                                {level === 1 ? (
                                    <>
                                        <div>
                                            {!loding ?
                                                <button
                                                    className={
                                                        errors.UserName ? "btn-blue-disabled" : "btn-blue"
                                                    }
                                                    disabled={errors.UserName}
                                                    onClick={handleInitiateForgrtPin}
                                                >
                                                    Get OTP
                                                </button>
                                                :
                                                <LodingButton text="Sending OTP" />
                                            }
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {level === 2 ? (
                                            <>

                                                <div>
                                                    <label
                                                        htmlFor="OTP"
                                                        className="block text-sm font-medium leading-6 text-gray-900"
                                                    >
                                                        OTP
                                                    </label>
                                                    <div className="mt-2">
                                                        <Input
                                                            placeholder="Enter OTP"
                                                            type="password"
                                                            id="OTP"
                                                            Icon={<HiMenu className="h-6 w-6" />}
                                                            value={values.OTP}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            isError={errors.OTP && touched.OTP}
                                                        />
                                                        {errors.OTP && touched.OTP && (
                                                            <p className="text-red-600 text-xs">
                                                                {errors.OTP}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="flex justify-center">
                                                    <button
                                                        className="hyper-link flex w-full justify-center cursor-pointer px-3 py-1.5 text-sm"
                                                        onClick={() => { setLevel(1); setValues({ ...values, OTP: "" }) }}
                                                    >
                                                        Back
                                                    </button>
                                                    <button
                                                        className={
                                                            errors.OTP ? "btn-blue-disabled" : "btn-blue"
                                                        }
                                                        disabled={errors.OTP}
                                                        onClick={() => setLevel(3)}
                                                    >
                                                        Varify OTP
                                                    </button>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                {level === 3 ? (
                                                    <>

                                                        <div>
                                                            <label
                                                                htmlFor="NewPass"
                                                                className="block text-sm font-medium leading-6 text-gray-900"
                                                            >
                                                                New Pin
                                                            </label>
                                                            <div className="mt-2">
                                                                <Input
                                                                    placeholder="Enter new password"
                                                                    type="password"
                                                                    id="NewPass"
                                                                    Icon={<HiMenu className="h-6 w-6" />}
                                                                    value={values.NewPass}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    isError={
                                                                        errors.NewPass && touched.NewPass
                                                                    }
                                                                />
                                                                {errors.NewPass && touched.NewPass && (
                                                                    <p className="text-red-600 text-xs">
                                                                        {errors.NewPass}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <label
                                                                htmlFor="ConfirmPassword"
                                                                className="block text-sm font-medium leading-6 text-gray-900"
                                                            >
                                                                Confirm Pin
                                                            </label>
                                                            <div className="mt-2">
                                                                <Input
                                                                    placeholder="Enter confirm password"
                                                                    type="password"
                                                                    id="ConfirmPassword"
                                                                    Icon={<HiMenu className="h-6 w-6" />}
                                                                    value={values.ConfirmPassword}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    isError={
                                                                        errors.ConfirmPassword &&
                                                                        touched.ConfirmPassword
                                                                    }
                                                                />
                                                                {errors.ConfirmPassword &&
                                                                    touched.ConfirmPassword && (
                                                                        <p className="text-red-600 text-xs">
                                                                            {errors.ConfirmPassword}
                                                                        </p>
                                                                    )}
                                                            </div>
                                                        </div>

                                                        <div className="flex">
                                                            <button
                                                                className="hyper-link flex w-full justify-center cursor-pointer px-3 py-1.5 text-sm"
                                                                onClick={() => { setLevel(2) }}
                                                            >
                                                                Change OTP
                                                            </button>

                                                            {!loding ?
                                                                <button className={!isValid ? "btn-blue-disabled" : "btn-blue"} disabled={!isValid} type='submit'>
                                                                    Reset Password
                                                                </button>
                                                                :
                                                                <LodingButton text={"Resetting"} />
                                                            }
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="flex flex-col">

                                                            <h1 className="text-2xl">
                                                                Pin has been updated successfully.
                                                            </h1>
                                                            <div className="flex">
                                                                <button
                                                                    className="hyper-link flex w-full justify-center cursor-pointer px-3 py-1.5 text-sm"
                                                                    onClick={() => {
                                                                        setLevel(1); setValues({
                                                                            UserName: "username",
                                                                            OTP: "",
                                                                            NewPass: "",
                                                                            ConfirmPassword: "",
                                                                        })
                                                                    }}
                                                                >
                                                                    Reset Again
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}
                            </div>

                        </div>
                    </form>

                </Card>
            </div>
        </Container>
    );
}
